export class UIHelper {
	static rem = (...args: number[]): string => {
		try {
			if (!args.every((el) => typeof el === 'number')) {
				throw new Error('Not valid input');
			}

			const documentFontSize =
				Number(getComputedStyle(document.documentElement).fontSize.replace('px', '')) || 16;
			return args.reduce((prev, curr) => `${prev} ${curr / documentFontSize}rem`, '').trim();
		} catch (e) {
			return '';
		}
	};
}
